// src/pages/FaqPublicResults/components/HelpHero.jsx
import React from "react";
import { FaBookOpen, FaSearch, FaTrophy, FaUsers } from "react-icons/fa";

export default function HelpHero({ totalSections, visibleSections }) {
  return (
    <section className="overflow-hidden rounded-[32px] bg-slate-950 shadow-xl dark:bg-slate-900">
      <div className="relative p-5 sm:p-7 lg:p-8">
        <div className="absolute -right-16 -top-16 h-52 w-52 rounded-full bg-indigo-500/25 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-40 w-40 rounded-full bg-pink-500/20 blur-3xl" />
        <div className="absolute -bottom-20 -left-20 h-56 w-56 rounded-full bg-blue-500/15 blur-3xl" />

        <div className="relative">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-white/80">
            <FaBookOpen />
            Centre d’aide
          </div>

          <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
            Aide MonAppliTournoi
          </h1>

          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-300 sm:text-base">
            Retrouvez les principales informations pour consulter les résultats,
            organiser une compétition, gérer les pesées, les poules, les tapis,
            les combats et les photos.
          </p>
        </div>

        <div className="relative mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">
          <HeroStat icon={FaBookOpen} label="Rubriques" value={totalSections} />
          <HeroStat icon={FaSearch} label="Affichées" value={visibleSections} />
          <HeroStat icon={FaTrophy} label="Public & organisation" value="Judo" />
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[24px] border border-white/10 bg-white/[0.08] p-4 text-white shadow-sm backdrop-blur">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/10">
          <Icon />
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-wide text-white/60">
            {label}
          </div>
          <div className="mt-0.5 text-2xl font-bold">{value}</div>
        </div>
      </div>
    </div>
  );
}